module.exports = __webpack_public_path__ + "static/media/17-2.8e8c9786.mp3";